<!-- @author Renuka,
     @date 21-02-2025
     @description Exception Query popup component 
-->
     <div class="mainContent">

  <div class="header">
    <label class="textColour">Exception Queries</label>
  </div>

  <!-- Scrollable Content -->
  <div class="content-scroll">

    <form novalidate [formGroup]="validations_form" style="width: 100%;">

      <!-- ROW 1 -->
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Order Id</mat-label>
            <input matInput type="number" formControlName="orderId" title="Order Id">
            <mat-error *ngIf="validations_form.get('orderId').hasError('required')">
    Order Id is required
  </mat-error>

  <mat-error *ngIf="validations_form.get('orderId').hasError('min')">
    Order Id must be greater than 0
  </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Exception Type</mat-label>
            <mat-select formControlName="exceptionType" title="Exception Type">
              <mat-option value="Error">Error</mat-option>
              <mat-option value="Warning">Warning</mat-option>
            </mat-select>
             <mat-error *ngIf="validations_form.get('exceptionType').hasError('required')">
    Exception Type is required
  </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Execution Type</mat-label>
            <mat-select formControlName="executionType" title="Execution Type">
              <mat-option value="Pre Stage">Pre Stage</mat-option>
              <mat-option value="Post Stage">Post Stage</mat-option>
              <mat-option value="Post Transformation">Post Transformation</mat-option>
            </mat-select>
            <mat-error *ngIf="validations_form.get('executionType').hasError('required')">
    Execution Type is required
  </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Reference Source Objects</mat-label>
            <input matInput readonly title="Reference Source Objects"
                   (click)="searchableReferenceSourceObjects()"
                   [(ngModel)]="selectedReferenceSourceObjectsListNames"
                   formControlName="selectedReferenceSourceObjectsListNamesForm">
          </mat-form-field>
        </div>
      </div>

      <!-- ROW 2 -->
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Reference Transform</mat-label>
            <input matInput readonly title="Reference Transform"
                   (click)="searchableReferenceTargetObjects()"
                   [(ngModel)]="selectedReferenceTargetObjectsListNames"
                   formControlName="selectedReferenceTargetObjectsListNamesForm">
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Reference Value Mapping</mat-label>
            <mat-select multiple title="Reference Value Mapping" formControlName="selectedReferenceValueMappingForm"
                        [(ngModel)]="selectedReferenceValueMapping">
              <ng-container *ngFor="let data of codeListData">
                <mat-option *ngIf="data.status == 'Yes'" [value]="data.mappingTypeName">
                  {{data.mappingTypeName}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Reference Library Objects</mat-label>
            <input matInput readonly title="Reference Library Objects"
                   (click)="searchableReferenceLibraryObjects()"
                   [(ngModel)]="selectedReferenceLibraryObjectsListNames"
                   formControlName="selectedReferenceLibraryForm">
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Reference Global Objects</mat-label>
            <input matInput readonly title="Reference Global Objects"
                   (click)="searchableReferenceGlobalObjects()"
                   [(ngModel)]="selectedReferenceGlobalObjectsListNames"
                   formControlName="selectedReferenceGlobalObjectsListNamesForm">
          </mat-form-field>
        </div>
      </div>

      <!-- ROW 3 -->
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Reference Global Source Objects</mat-label>
            <input matInput readonly
            title="Reference Global Source Objects"
                   (click)="searchableReferenceGlobalSourceObjects()"
                   [(ngModel)]="selectedReferenceGlobalSourceObjectsListNames"
                   formControlName="selectedReferenceGlobalSourceObjectsListNamesForm">
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Global External Objects</mat-label>
            <input matInput readonly title="Global External Objects"
                   (click)="searchableGlobalExternalObjects()"
                   [(ngModel)]="selectedGlobalExternalObjectsListNames"
                   formControlName="selectedGlobalExternalObjectsListNamesForm">
          </mat-form-field>
        </div>
      </div>

      <!-- Exception Expression -->
      <div class="row topRowMargins" style="margin-bottom: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Exception Expression</label
            >
            <button i18n="@@CancelButton"
            type="button" (click)="openSqlBuilderPopUpForException()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            sql builder
          </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <!-- <textarea rows="5" #codeExceptionEditor></textarea> -->
               <app-code-editor
              [(value)]="exceptionExpressionDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
          </div>
        </div>

    </form>

  </div>

  <!-- Footer Buttons -->
  <div style="text-align: end; margin-top: 25px;">

            <form novalidate [formGroup]="formValidCheckbox">
                    <span *ngIf="showCreateAnother">
                        <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected" style="margin-right:1%" class="mat-checkbox-layout"></mat-checkbox>
                        <span>
                            Create another
                        </span>
                    </span>

            <button i18n="@@TargetClear" type="button" 
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"[style.background-color]="backgroundColorButton"(click)="saveMethod()"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:150px;color: white;">{{this.buttonName}}</button>

            <button i18n="@@TargetCancel" type="button"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" (click)="cancel()"[style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:150px;color: white;">Cancel</button>
            </form>
          </div>

</div>
